import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import styled from 'styled-components'

import { FlexBox, Grid } from '../../../components/Base/Base'
import { Button } from '../../../components/Button/Button'
import { useUserProvider } from '../../../components/Context/UserContext'
import { Text } from '../../../components/Text/Text'
import { isConsole } from '../../../config/config'
import { HandlerOf } from '../../../helpers/typeHelper'
import { JOB_STATUS_DICT_KEYS, JobStatus, JobStatusDetail } from '../../../models/job'
import { User } from '../../../models/user'
import { lightGray1, primaryBlack } from '../../../theme/colors'
import { ProfileJobOrderByDropown } from './ProfileJobOrderByDropown'
import { ProfileJobOrderBy, ProfileJobOrderByDirection } from './ProfileJobs'
import { ProfileJobStatusFilterDropown } from './ProfileJobStatusDetailDropown'

interface ProfileJobsHeaderProps {
  user: User
  statusDetailFilter: JobStatusDetail[]
  setStatusDetailFilter: HandlerOf<JobStatusDetail[]>
  orderBy: ProfileJobOrderBy
  setOrderBy: HandlerOf<ProfileJobOrderBy>
  orderByDirection: ProfileJobOrderByDirection
  setOrderByDirection: HandlerOf<ProfileJobOrderByDirection>
  hasJobs: boolean
  isInsideSidebar?: boolean
  hiddenStatusOptions?: JOB_STATUS_DICT_KEYS[]
  onlyOneStatus?: JobStatus
  count?: number
}

export function ProfileJobsHeader({
  user,
  statusDetailFilter,
  setStatusDetailFilter,
  orderBy,
  setOrderBy,
  orderByDirection,
  setOrderByDirection,
  hasJobs,
  isInsideSidebar,
  hiddenStatusOptions,
  onlyOneStatus,
  count,
}: ProfileJobsHeaderProps) {
  const { subscription } = useUserProvider()

  function handleOrderByChange(orderBy: ProfileJobOrderBy, orderByDirection: ProfileJobOrderByDirection) {
    setOrderBy(orderBy)
    setOrderByDirection(orderByDirection)
  }

  return (
    <Grid
      columns="minmax(50%, 1fr) auto"
      xsColumns="1fr"
      gap="15px"
      style={isInsideSidebar ? { padding: '0 40px 16px' } : undefined}
    >
      {!!onlyOneStatus && (
        <FlexBox gap="12px">
          <Text variant="uppercaseLabel2" fontColor={primaryBlack}>
            {onlyOneStatus}
          </Text>
          {!!count && (
            <Text variant="uppercaseLabel2" fontColor={lightGray1}>
              {count}
            </Text>
          )}
        </FlexBox>
      )}

      {hasJobs ? (
        <>
          {isConsole() && subscription?.isPremium && !onlyOneStatus && (
            <div>
              <ProfileJobStatusFilterDropown
                statusFilter={statusDetailFilter}
                onChange={setStatusDetailFilter}
                hiddenOptions={hiddenStatusOptions}
              />
            </div>
          )}

          {!isInsideSidebar && (
            <div>
              <ProfileJobOrderByDropown
                orderBy={orderBy}
                orderByDirection={orderByDirection}
                onChange={handleOrderByChange}
                isDisabled={!hasJobs}
                align={isConsole() ? 'right' : 'left'}
              />
            </div>
          )}
        </>
      ) : null}
      {!isConsole() && (
        <FlexBox justifyContent="flex-start">
          <Button
            variant="text"
            href={`/jobs/past/?user=${user.id}`}
            icon={<StyledKeyboardArrowRightIcon />}
            iconOnRight
          >
            View past jobs
          </Button>
        </FlexBox>
      )}
    </Grid>
  )
}

const StyledKeyboardArrowRightIcon = styled(KeyboardArrowRightIcon)`
  position: relative;
  top: 1px;
`
